import { IBasketProductItem } from "@/entities";
import { IOrder, Order } from "@/entities/order/order";
import { Module } from "vuex";
import {
    IActions,
    ICartDataState,
    IGetters,
    IMutations,
} from "./cartData.type";

export const getters: IGetters = {
    isSelectAll: (state) => {
        const list = [
            ...state.inStockList,
            ...state.outOfStockList,
            ...state.overStockList,
            ...state.unavailableList,
        ];
        const selectedList = list.filter((p) => {
            return p.selected;
        });

        if (selectedList.length == list.length) {
            return true;
        }
        return false;
    },
    selectedProducts: (state) => {
        const list = [
            ...state.inStockList,
            ...state.outOfStockList,
            ...state.overStockList,
            ...state.unavailableList,
        ];
        const selectedList = list.filter((p) => {
            return p.selected;
        });
        return selectedList;
    },
    totalProduct: (state) => {
        const list = [
            ...state.inStockList,
            ...state.outOfStockList,
            ...state.overStockList,
            ...state.unavailableList,
        ];
        return list.length;
    },
    totalProductCount: (state) => {
        const list = [
            ...state.inStockList,
            ...state.outOfStockList,
            ...state.overStockList,
            ...state.unavailableList,
        ];
        return list.reduce((acc, p) => {
            return acc + p.basketItem.quantity;
        }, 0);
    },
};

export const mutations: IMutations = {
    setLoading: (state, payload) => {
        state.loading = payload;
    },
    setComputing: (state, payload) => {
        state.computingCart = payload;
    },
    setInStockList: (state, payload) => {
        state.inStockList = payload;
    },
    setOutOfStockList: (state, payload) => {
        state.outOfStockList = payload;
    },
    setUnavailableList: (state, payload) => {
        state.unavailableList = payload;
    },
    setOverStockList: (state, payload) => {
        state.overStockList = payload;
    },
    setSelect: (state, payload) => {
        // check inStockList
        for (let index = 0; index < state.inStockList.length; index++) {
            if (
                state.inStockList[index].basketItem.sku ==
                payload.basketItem.sku
            ) {
                state.inStockList[index] = payload;

                // force update
                state.inStockList = [...state.inStockList];
                return;
            }
        }

        // check outOfStockList
        for (let index = 0; index < state.outOfStockList.length; index++) {
            if (
                state.outOfStockList[index].basketItem.sku ==
                payload.basketItem.sku
            ) {
                state.outOfStockList[index] = payload;

                // force update
                state.outOfStockList = [...state.outOfStockList];
                return;
            }
        }

        // check unavailableList
        for (let index = 0; index < state.unavailableList.length; index++) {
            if (
                state.unavailableList[index].basketItem.sku ==
                payload.basketItem.sku
            ) {
                state.unavailableList[index] = payload;

                // force update
                state.unavailableList = [...state.unavailableList];
                return;
            }
        }
    },
    setSelectAll: (state, payload) => {
        for (let index = 0; index < state.inStockList.length; index++) {
            state.inStockList[index].selected = payload;
        }
        for (let index = 0; index < state.outOfStockList.length; index++) {
            state.outOfStockList[index].selected = payload;
        }
        for (let index = 0; index < state.overStockList.length; index++) {
            state.overStockList[index].selected = payload;
        }
        for (let index = 0; index < state.unavailableList.length; index++) {
            state.unavailableList[index].selected = payload;
        }
    },
    setCost: (state, payload) => {
        state.subTotal = payload.subTotal!;
        state.discountTotal = payload.totalDiscount!;
        state.grandTotal = payload.grandTotal!;
    },
    // setBasket: (state, payload) => {
    //     state.basket = payload;
    // },
    // clearBasket: (state) => {
    //     state.basket = undefined;
    // },
    // setCustomers: (state, payload) => {
    //     // state.customers = payload;
    // }
};

export const actions: IActions = {
    computeCartData(this, context, { productList, changeBasket = true }): void {
        console.log("changeBasket", changeBasket);
        const branch = (context.rootState as any)["branch"];
        const currentBranch = parseInt(branch["branch"].code);
        const productMap = this.$services.catalog.productMap;

        const inStockList: IBasketProductItem[] = [];
        const outOfStockList: IBasketProductItem[] = [];
        const overStockList: IBasketProductItem[] = [];
        const unavailableList: IBasketProductItem[] = [];
        for (let index = 0; index < productList.length; index++) {
            const cprcode = productList[index].sku;
            const p = productMap?.get(cprcode);

            if (p) {
                if (!p.isAvailableAt(currentBranch)) {
                    let selected = true;
                    if (!changeBasket) {
                        // same basket then use previous selected state
                        const x = context.state.unavailableList.find(
                            (x) => x.basketItem.sku === p.cprcode
                        );          
                        if (x) {
                            selected = x.selected;
                        }
                    }

                    unavailableList.push({
                        basketItem: productList[index],
                        product: p,
                        selected,
                    });
                    continue;
                }

                const stock = p.stockAt(currentBranch);
                if (stock <= 0) {
                    let selected = true;
                    if (!changeBasket) {
                        // same basket then use previous selected state
                        const x = context.state.outOfStockList.find(
                            (x) => x.basketItem.sku === p.cprcode
                        );
                        if (x) {
                            selected = x.selected;
                        }
                    }
                    outOfStockList.push({
                        basketItem: productList[index],
                        product: p,
                        selected,
                    });
                    continue;
                }

                if (stock >= productList[index].quantity) {
                    let selected = true;
                    if (!changeBasket) {
                        // same basket then use previous selected state
                        const x = context.state.inStockList.find(
                            (x) => x.basketItem.sku === p.cprcode
                        );
                        if (x) {
                            selected = x.selected;
                        }
                    }
                    inStockList.push({
                        basketItem: productList[index],
                        product: p,
                        selected,
                    });
                    continue;
                }

                let selected = true;
                if (!changeBasket) {
                    // same basket then use previous selected state
                    const x = context.state.overStockList.find(
                        (x) => x.basketItem.sku === p.cprcode
                    );
                    if (x) {
                        selected = x.selected;
                    }
                }
                overStockList.push({
                    basketItem: productList[index],
                    product: p,
                    selected,
                });
            }
        }

        console.log(inStockList, outOfStockList, unavailableList);

        context.commit("setInStockList", inStockList);
        context.commit("setOutOfStockList", outOfStockList);
        context.commit("setOverStockList", overStockList);
        context.commit("setUnavailableList", unavailableList);
    },
    async getCost(this, context, payload): Promise<void> {
        try {
            context.commit("setLoading", true);
            // get apikey
            const apikey = await this.$services.authentication.getApikey();

            const branch = (context.rootState as any)["branch"];

            // create order class
            const order = new Order({
                branchId: branch["branch"].code,
                productList: (
                    context.getters["selectedProducts"] as IBasketProductItem[]
                ).map((p) => {
                    return {
                        productName: p.product.hemaNameEn,
                        quantity: p.basketItem.quantity,
                        cprcode: p.product.cprcode,
                    };
                }),
            });

            const response = await this.$services.calculatePrice.suggestCoupon(order, apikey!.key!);
            order.couponCodeList = response.calculateCostInput.couponCodeList;
            const result = await this.$services.calculatePrice.getResolveCoupon(order, apikey!.key!);

            context.commit("setCost", result);
        } catch (error) {
            console.warn(error);
        } finally {
            context.commit("setLoading", false);
        }
    },
};

const cart: Module<ICartDataState, ICartDataState> = {
    namespaced: true,
    state: {
        loading: false,
        computingCart: false,
        inStockList: [],
        outOfStockList: [],
        overStockList: [],
        unavailableList: [],
        subTotal: null,
        discountTotal: null,
        grandTotal: null,
    },
    getters,
    mutations,
    actions,
};

export default cart;
